export const pathMetadata = {
  '/404': { embeddable: true, withNavigation: true },
  '/about-us': { embeddable: false, withNavigation: true },
  '/agencies': { embeddable: false, withNavigation: true },
  '/contact': { embeddable: false, withNavigation: true },
  '/report-download': { embeddable: false, withNavigation: true },
  '/club': { embeddable: false, withNavigation: true },
  '/content-api': { embeddable: false, withNavigation: true },
  '/consulting': { embeddable: false, withNavigation: true },
  '/api-docs': { embeddable: false, withNavigation: false },
  '/features': { embeddable: false, withNavigation: true },
  '/fitness-apps': { embeddable: false, withNavigation: true },
  '/glp1-weight-management': { embeddable: false, withNavigation: true },
  '/digital-physio': { embeddable: false, withNavigation: true },
  '/exercise-library': { embeddable: false, withNavigation: true },
  '/exercise-video-api': { embeddable: false, withNavigation: true },
  '/ai-workout-video-generator': { embeddable: false, withNavigation: true },
  '/fitness-content-licensing': { embeddable: false, withNavigation: true },
  '/connected-fitness': { embeddable: false, withNavigation: true },
  '/gyms': { embeddable: false, withNavigation: true },
  '/': { embeddable: false, withNavigation: true },
  '/legal': { embeddable: false, withNavigation: true },
  '/legal-teams': { embeddable: false, withNavigation: true },
  '/legal-api': { embeddable: false, withNavigation: true },
  '/legal-club': { embeddable: true, withNavigation: true },
  '/partners': { embeddable: false, withNavigation: true },
  '/become-a-partner': { embeddable: false, withNavigation: true },
  '/resellers': { embeddable: false, withNavigation: true },
  '/pricing': { embeddable: false, withNavigation: true },
  '/privacy': { embeddable: false, withNavigation: true },
  '/wix': { embeddable: false, withNavigation: true },
  '/wellness-providers': { embeddable: false, withNavigation: true },
  '/redirect-to': { embeddable: true, withNavigation: false },
};

export const embeddablePaths: Array<string> = (Object.keys(pathMetadata) as Array<keyof typeof pathMetadata>).filter(
  (path) => pathMetadata[path].embeddable,
);

export const nonEmbeddablePaths: Array<string> = (Object.keys(pathMetadata) as Array<keyof typeof pathMetadata>).filter(
  (path) => !pathMetadata[path].embeddable,
);

export const pathsWithoutNavigation: Array<string> = (
  Object.keys(pathMetadata) as Array<keyof typeof pathMetadata>
).filter((path) => !pathMetadata[path].withNavigation);
